/* ==========================================================
   ATUALIZA EMAIL DO FOOTER
   - Garante que o email exibido no rodapé seja apoyo@bellasirena.shop
   - Substitui emails antigos (contacto@tumarca.com, contacto@bellasirena.com, etc.)
   ========================================================== */
(function () {
  'use strict';

  var NEW_EMAIL = 'apoyo@bellasirena.shop';

  function updateFooterEmail() {
    var footer = document.querySelector('.bs-footer');
    if (!footer) return;

    var cols = footer.querySelectorAll('.bs-footer-col');
    var contactCol = null;

    // Procura coluna de Contacto
    cols.forEach(function (col) {
      var h5 = col.querySelector('h5');
      if (!h5) return;
      var title = h5.textContent.toLowerCase();
      if (title.indexOf('contacto') !== -1 || title.indexOf('contact') !== -1) {
        contactCol = col;
      }
    });

    if (!contactCol) return;
    if (contactCol.dataset.bsEmailDone === '1') return;

    // Procura parágrafos com email e substitui
    var paragraphs = contactCol.querySelectorAll('p');
    var emailFound = false;

    paragraphs.forEach(function (p) {
      var text = p.textContent;
      // Substitui qualquer email típico por nosso novo
      if (/[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(text)) {
        // Mantém emoji/prefixo, troca só o email
        p.innerHTML = p.innerHTML.replace(
          /([a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
          '<a href="mailto:' + NEW_EMAIL + '" class="bs-footer-email-link">' + NEW_EMAIL + '</a>'
        );
        emailFound = true;
      }
    });

    // Se nenhum email foi achado, ADICIONA um parágrafo no início com o email
    if (!emailFound) {
      var p = document.createElement('p');
      p.innerHTML = '📧 <a href="mailto:' + NEW_EMAIL + '" class="bs-footer-email-link">' + NEW_EMAIL + '</a>';
      // Insere logo após o h5 (título)
      var h5 = contactCol.querySelector('h5');
      if (h5 && h5.nextSibling) {
        contactCol.insertBefore(p, h5.nextSibling);
      } else {
        contactCol.appendChild(p);
      }
    }

    contactCol.dataset.bsEmailDone = '1';
  }

  function run() { try { updateFooterEmail(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  [400, 1200, 2500].forEach(function (ms) { setTimeout(run, ms); });
})();
